<template>
  <el-dialog
    width="700px"
    :show-close="false"
    :visible.sync="visible"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <!-- 上传窗口 -->
    <div v-if="step==1" class="import-product-dialog">
      <p class="dialog-head">Import orders with Excel</p>
      <el-divider></el-divider>
      <div class="title-info">
        <p style="margin-top: 30px">Download the template and fill in the order information.</p>
        <el-button type="text" @click="download()">Order Import Template.xls</el-button>
      </div>
      <div class="upload-info">
        <el-upload
          class="upload-demo"
          accept=".xlsx, .xls"
          :headers="headers"
          :on-success="handelSuccess"
          :on-progress="handelProgress"
          :show-file-list="false"
          drag
          :before-upload="handleBeforeUpload"
          :action="uploadApi"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">or drop file to upload，or&nbsp;<em>click upload</em></div>
          <div class="el-upload__tip" slot="tip">Supports .xlsx, .xls, format files-the size may not exceed 10M</div>
        </el-upload>

      </div>
      <div class="btn">
        <div class="submit">Submit</div>
        <div class="cancel" @click="visible = false">Cancel</div>
      </div>
    </div>

    <!-- 格式校验中 -->
    <div v-else-if="step==2" class="check-format">
      <div v-loading="true"></div>
      <p>{{ isCheckData ? 'Validation format' : 'Importing product' }}</p>
      <div v-if="isCheckData">Format validation may take a while uploaded-please do not operate the current page</div>
      <div v-else>It may take a while for the product to be uploaded - please do not operate the current page</div>
    </div>

    <!-- 结果 -->
    <div v-else-if="step==3" class="result">
      <!-- 校验文件结果 -->
      <template v-if="isCheckData">
        <p>Template validation format</p>
        <p>Total <span>{{ uploadCheckObj['orderCount'] | numberValueFormat }}</span> Orders format valid action,
          <span>{{ uploadCheckObj['successCount'] | numberValueFormat }} </span> successful,
          <span>{{ uploadCheckObj['failureCount'] | numberValueFormat }} </span> failed,
        <p class="submit" v-if="uploadCheckObj['checkFailureUrl']" @click="download(uploadCheckObj['checkFailureUrl'])">
          Download failed product data</p>
        <div class="btn">
          <div class="cancel" @click="visible = false">Cancel</div>
          <div class="submit" v-if="uploadCheckObj['checkSuccessUrl']" @click="importOrderData">Upload verified orders
          </div>
        </div>
      </template>
      <!-- 导入结果 -->
      <template v-else>
        <p>Product Import result</p>
        <p>Total
          <span>{{ uploadObj['orderCount'] | numberValueFormat }}</span> Orders uploaded,
          <span>{{ uploadObj['orderUploadSuccessCount'] | numberValueFormat }}</span> successes,
          <span>{{ uploadObj['orderUploadFailureCount'] | numberValueFormat }}</span> failures,
        </p>
        <p @click="download(uploadObj['uploadResultUrl'] )">Download import result</p>
        <p>After the goods are approved, they will be displayed on the ShopVidi website</p>
        <div class="btn">
          <div class="submit" @click="visible = false">Ok</div>
        </div>
      </template>
    </div>

    <!-- 超时 -->
    <div v-else-if="step==504" class="time-out">
      <p><i class="el-icon-warning-outline"></i></p>
      <p>Upload Network Timeout, please re-upload</p>
      <div class="btn">
        <div class="submit" @click="visible = false">Ok</div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import {getAction, putAction, downloadStaticFile} from '@/api/manage.js'
import Vue from 'vue'
import {postAction} from '../../api/manage'

export default {
  name: 'import-product',
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      step: 1,
      isCheckData: false,
      basePath: process.env.API_URL,
      uploadApi: '',
      brandManagementMode: Vue.ls.get('userInfo').supplierManagementModel,
      headers: {
        'x-access-token': Vue.ls.get('token')
      },
      /* 校验结果 */
      uploadCheckObj: {},
      /* 导入结果 */
      uploadObj: {},
      brandOptions: [],
      brandId: '',
      userSource: Vue.ls.get('userInfo').userSource // 2公有品牌 3私有品牌

    }
  },
  created() {
  },
  methods: {
    show() {
      this.step = 1
      this.visible = true
      this.isCheckData = true
      this.uploadCheckObj = {}
    },
    // 上传文件前验证brandId
    handleBeforeUpload() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.uploadApi = this.basePath + `/order/api/v0.2/suppliers/${Vue.ls.get('userInfo').id}/batch-orders/verify`
          resolve()
        })
      })
    },
    download(url) {
      if (url) {
        downloadStaticFile(url)
        return
      }
      downloadStaticFile('https://master-shopvidi.s3.amazonaws.com/batch_order/bulk_order_template/Bulk+order+template.xlsx')
    },

    handelSuccess(response, file, fileList) {
      this.step = 3
      if (response['success']) {
        this.uploadCheckObj = response['result']
        this.$message.success('Verification completed!')
      } else {
        this.$message.error(response['message'])
      }
    },
    handelProgress(event, file, fileList) {
      this.step = 2
      this.isCheckData = true
    },
    async importOrderData() {
      this.step = 2
      this.isCheckData = false
      const params = {successUrl: this.uploadCheckObj['checkSuccessUrl']}
      let res = await postAction(`order/api/v0.2/suppliers/${Vue.ls.get('userInfo').id}/batch-orders`, params)
      if (res['success']) {
        this.uploadObj = res['result']
        this.visible = false
        this.$emit('loadData')
      } else {
        this.visible = false
        this.$message.error(res['message'])
      }
    }
  },
  filters: {
    numberValueFormat: (value) => {
      return !value ? 0 : value
    }
  }
}
</script>

<style lang="less" scoped>

.import-product-dialog {
  .dialog-head {
    color: #262B2F;
    font-family: Satoshi-Bold;
    padding: 15px 15px 0px;
    font-size: 16px;
  }

  .title-info {
    padding: 0px 30px 0 30px;

    .brand-title {
      color: #262B2F;
      font-family: Satoshi-Bold;
      margin-right: 10px;
    }
  }

  .upload-info, .btn {
    margin: 30px 30px 0;
    padding: 20px 0
  }

  .upload-info {
    border: 1px dotted #707070;
    text-align: center;
  }

}

.btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 30px;

  div {
    width: 120px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    cursor: pointer;
  }

  .submit {
    background: #000000;
    color: #ffffff;
  }

  .cancel {
    border: 1px solid #000000;
    margin-left: 20px;
    margin-right: 20px;
  }

}

.check-format {
  padding: 40px 30px;
  text-align: center;

  div:nth-child(1) {
    width: 40px;
    height: 40px;
    margin: 0 auto;

  }

  div:nth-child(3) {
    color: #8F8F8F;
    margin-top: 30px;
  }

  p {
    font-family: Satoshi-Bold;
    margin-top: 30px;
  }
}

.result {
  padding: 40px 30px;
  text-align: center;

  p {
    margin-top: 30px;
  }

  p:nth-child(1) {
    font-family: Satoshi-Bold;
  }

  p:nth-child(2) {
    span:nth-child(1) {
      font-family: Satoshi-Bold
    }

    span:nth-child(2) {
      color: #41B76A;
    }

    span:nth-child(3), span:nth-child(4) {
      color: #F77073;
    }
  }

  p:nth-child(3) {
    color: #F77073;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
  }

  p:nth-child(4) {
    color: #8F8F8F;
  }

  .btn {
    margin-top: 30px;
    padding-bottom: 0px;

    div {
      width: 180px;
    }
  }

}

.time-out {
  padding: 40px 30px;
  text-align: center;
  margin: 0 auto;

  p {
    margin-bottom: 30px;
  }

  p:nth-child(1) {
    font-size: 50px;
  }

  .btn {
    padding-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/wholesale/import-orders.vue